import Head from "next/head";
import React from "react";
import { OgData } from "src/functions/getOg";

type Props = {
  data: OgData;
};

export default function Headers({ data }: Props) {
  return (
    <Head>
      <title>{data.title}</title>
      <link rel="shortcut icon" href="/favicon.png" />

      {data.metas.map((meta, index) => {
        return (
          <meta key={index} property={meta.property} content={meta.content} />
        );
      })}
    </Head>
  );
}
